import { render } from "./Config.vue?vue&type=template&id=3c348f7b"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
script.render = render

export default script